const orgTypeMappings = {
    admin: 'admin',
    media_buyer: 'media buyer',
    co_managed_client: 'co-managed client',
    client: 'client',
    none: '',
};

export default orgTypeMappings;
